import axios from '@/components/api/axios';

async function purchases(bcNo) {
  let data = {
    bcNo: bcNo
  }
  const res = await axios.axiosGet('/api/purchases/getProductList', data);
  return res;
}



export default {
  purchases,
}



// WEBPACK FOOTER //
// ./src/components/api/product.js